import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals.ts";
import { Amplify } from "aws-amplify";
import AWSCognitoConfig from "./utils/AWSCognitoConfig.ts";
import { Hub } from "aws-amplify";
import { store, loadFederatedPlugins } from "./redux/store.ts";
import { Provider as ReduxProvider } from "react-redux";
import { LicenseInfo } from "@mui/x-license";
// Import required Redux actions
import { authAction } from "./redux/actions/authActions.ts";
import { logout, setAuthFailed } from "./redux/slices/authSlice.ts";
import { datadogRum } from "@datadog/browser-rum";

// Set the license key for MUI X components
LicenseInfo.setLicenseKey(
  "26580a346d995318fd4d5710f40d1de5Tz04NTMwNixFPTE3NDA3ODE0NjAwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI=",
);

datadogRum.init({
  applicationId: "8952dbef-9981-4b19-862b-37f7d7d71a9d",
  clientToken: "pubb32fc7eac6d786013f4fb8a0a0ad5ead",
  site: "datadoghq.com",
  service: "freightplus-one",
  env: process.env.REACT_APP_DATADOG_RUM_ENV || "local",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "allow",
  trackBfcacheViews: true,

  startSessionReplayRecordingManually: true,
});

// The store exists synchronously (see store.ts), so this listener can dispatch
// directly — auth events can no longer be dropped while the store is loading.
// Registered BEFORE Amplify.configure(), because configure() is what kicks off
// parsing of the OAuth redirect response and may fire these events.
Hub.listen("auth", ({ payload: { event, data } }) => {
  switch (event) {
    case "signIn":
    case "cognitoHostedUI":
      store.dispatch(authAction(data));
      break;
    case "signIn_failure":
    case "cognitoHostedUI_failure":
      console.error("Sign-in failed: ", data);
      store.dispatch(
        setAuthFailed("Sign-in didn't complete. Please try again."),
      );
      break;
    case "signOut":
      store.dispatch(logout());
      break;
  }
});

Amplify.configure(AWSCognitoConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// ✅ Add global flag here
(window as any).__IS_PORTAL__ = true;

// Render immediately — login must never wait on the federated remotes.
root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </React.StrictMode>,
);

// Download the federated remotes in the background and inject their
// reducers/sagas into the live store as each one arrives. Everything that
// needs them sits behind login, which gives them ample time to load.
loadFederatedPlugins();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
